import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import ProductDetail from "./pages/ProductDetail";
import CityLanding from "./pages/CityLanding";
import MedicalCard from "./pages/MedicalCard";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App grain min-h-screen bg-ink text-bone">
      <BrowserRouter>
        <CartProvider>
          <ScrollManager />
          <Header />
          <CartDrawer />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/locations/:slug" element={<CityLanding />} />
            <Route path="/medical-card" element={<MedicalCard />} />
          </Routes>
          <Footer />
          <Toaster position="bottom-right" theme="dark" richColors />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
